/*
  Bilväljaren (SEL-ID) – rullgardiner för hela butiken.

  Läser fordonsregistret (assets/dg-bilval-fordon.json, byggt av scripts/bilval/bygg-register.mjs).
  Varje nod: {l: etikett, t: typ, b: barn} eller slutval {l, t, s: [SEL-ID], n: antal produkter}.
  Typer: M Bilmärke · O Modell · G Generation · U Utrustning · V Variant.

  Flöde (Tims beslut 2026-09-30):
    1. Alla fält syns hela tiden: Bilmärke, Modell, Generation, Utrustning, Variant. De som inte kan
       väljas än, eller inte finns för bilen, är gråa och visar bara fältnamnet.
    2. Bilmärke → Modell → Generation väljs i ordning. Ligger utrustning/variant före generationen i
       trädet (Audi A3/S3/RS3 › RS3 › 8V) väljs de också i ordning.
    3. När generationen är vald (eller grenen saknar generation) låses Utrustning och Variant upp;
       de är frivilliga och smalnar av varandra.
    4. "Visa delar" går att trycka redan efter bilmärket. Resultatet är alla SEL-ID under valen.

  Användning: <div data-dg-bilval data-register="{{ 'dg-bilval-fordon.json' | asset_url }}" data-rubrik="Välj din bil" data-knapp="Visa delar"></div>
  Händelse: 'dg-bilval:visa' (detail: {sel, etiketter, bil}). Går att avbryta med preventDefault()
  (testsidorna gör det); annars skickas kunden vidare enligt plan A nedan.
  Kundens bil sparas i localStorage 'dg_bilval' och händelsen 'dg-bilval:bil' skickas vid ändring.

  Plan A (Tims beslut 2026-10-04, KATALOGSTANDARD/02):
    "Visa delar" → märkessidan /collections/<märke>. Är mer än märket valt filtreras sidan på bilens
    SEL-ID i adressen (filter.p.m.custom.sel_ids). Står kunden på en kategorisida filtreras den i stället.
    Från en produktsida går knappen till märkessidan (Tim 2026-10-29: förut stannade kunden och inget hände).
    Med vald bil filtreras alla kategorisidor, sökresultatet och den egna märkessidan (bara märke valt →
    filter.p.m.custom.bilmarke, så att produkter utan passform aldrig visas). Andra märkens
    märkessidor filtreras inte. Sidor med fler än 5 000 produkter (där Shopify inte filtrerar) skickar
    kunden till märkessidan, med sidans avgränsning som filter (data-omfang: leverantören för Maxton Design,
    annars sidans produkttyper; 2026-10-08, se sections/dg-bilval-bar.liquid). ✕ tar bort filtret. Filtren måste finnas i Search & Discovery.
    Med vald bil visas bara produkter med passform (SEL-ID), även i kategorier där ingen produkt har det än
    (Tims beslut 2026-10-06). Blir en filtrerad kategori tom visas rutan "Inget här passar din bil"
    (snippets/dg-bilval-tom.liquid).
*/
(function () {
  'use strict';
  // Skriptet kan laddas av flera sektioner på samma sida (kortet + raden) – kör bara en gång.
  if (window.DGBilval) return;

  var LAGRING = 'dg_bilval';
  var TYPNAMN = { M: 'Bilmärke', O: 'Modell', G: 'Generation', U: 'Utrustning', V: 'Kaross' };
  var registerCache = {};

  // ---------- Register ----------
  function hamtaRegister(url) {
    if (!registerCache[url]) {
      registerCache[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('Registret kunde inte hämtas (' + r.status + ')'); return r.json(); })
        .then(function (reg) {
          // Märkessidornas adresser sparas för den tidiga omdirigeringen i sections/dg-bilval-bar.liquid.
          try { window.localStorage.setItem('dg_bilval_marken', JSON.stringify(markesHandles(reg))); } catch (e) {}
          return forbered(reg);
        });
    }
    return registerCache[url];
  }

  // Räknar ut per nod: _g = har generation i sig eller under sig, _n = produkter i grenen (för att dölja tomma val).
  function forbered(reg) {
    (function gå(noder) {
      noder.forEach(function (n) {
        if (n.b) {
          gå(n.b);
          n._g = n.t === 'G' || n.b.some(function (c) { return c._g; });
          n._n = n.b.reduce(function (a, c) { return a + c._n; }, 0);
        } else {
          n._g = n.t === 'G';
          n._n = n.n || 0;
        }
      });
    })(reg.trad);
    return reg;
  }

  function synliga(noder) { return (noder || []).filter(function (n) { return n._n > 0; }); }

  // Ankaret är noden där de fasta stegen slutar: en generation, eller en nod utan generation under sig.
  // Bilmärke (steg 0) är aldrig ankare – modell väljs alltid.
  function arAnkare(n, index) { return index >= 1 && (n.t === 'G' || !n._g); }

  function typAvGrupp(noder) {
    var r = {};
    noder.forEach(function (n) { r[n.t] = (r[n.t] || 0) + 1; });
    return Object.keys(r).sort(function (a, b) { return r[b] - r[a]; })[0] || 'G';
  }

  // Slutvalen under ankaret som poster: {sel, varden: {'U#1': 'R', 'V#1': 'Variant'}}.
  function poster(ankare) {
    var ut = [];
    (function gå(n, varden, raknare) {
      if (!n.b) { if (n._n > 0) ut.push({ sel: n.s, varden: varden }); return; }
      synliga(n.b).forEach(function (c) {
        var r = Object.assign({}, raknare);
        r[c.t] = (r[c.t] || 0) + 1;
        var v = Object.assign({}, varden);
        v[c.t + '#' + r[c.t]] = c.l;
        gå(c, v, r);
      });
    })(ankare, {}, {});
    return ut;
  }

  // Valfria fält i trädets ordning (U#1, V#1, U#2 …).
  function falt(post) {
    var ordning = [];
    post.forEach(function (p) {
      Object.keys(p.varden).forEach(function (k, i) {
        var f = ordning.filter(function (x) { return x.k === k; })[0];
        if (!f) ordning.push(f = { k: k, pos: [] });
        f.pos.push(i);
      });
    });
    ordning.forEach(function (f) { f.snitt = f.pos.reduce(function (a, b) { return a + b; }, 0) / f.pos.length; });
    return ordning.sort(function (a, b) { return a.snitt - b.snitt; }).map(function (f) {
      var typ = f.k.split('#')[0], nr = f.k.split('#')[1];
      return { k: f.k, namn: TYPNAMN[typ] + (nr !== '1' ? ' ' + nr : '') };
    });
  }

  function escHtml(t) { return String(t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function unika(lista) { var s = {}; return lista.filter(function (x) { return s[x] ? false : (s[x] = true); }); }

  // ---------- Kundens bil ----------
  function lasBil() { try { return JSON.parse(window.localStorage.getItem(LAGRING)); } catch (e) { return null; } }
  function sparaBil(bil) {
    try { bil ? window.localStorage.setItem(LAGRING, JSON.stringify(bil)) : window.localStorage.removeItem(LAGRING); } catch (e) {}
    document.dispatchEvent(new CustomEvent('dg-bilval:bil', { detail: bil }));
  }

  // ---------- Väljaren ----------
  function Valjare(rot, reg) {
    this.rot = rot;
    this.reg = reg;
    this.steg = [];      // valda noder i de fasta stegen
    this.ankare = null;  // nod där de valfria fälten börjar
    this.val = {};       // valfria fält: {'U#1': 'R'}
    this.bygg();
    var bil = lasBil();
    if (bil && bil.v === 1 && bil.steg) this.aterstall(bil);
    this.rita();
    // Håll alla väljare på sidan i takt (stora kortet, panelen i raden, fliken "Vald bil").
    var self = this;
    document.addEventListener('dg-bilval:bil', function (e) {
      self.steg = []; self.ankare = null; self.val = {};
      if (e.detail && e.detail.v === 1 && e.detail.steg) self.aterstall(e.detail);
      self.rita();
    });
  }

  Valjare.prototype.bygg = function () {
    this.rot.classList.add('dg-bilval');
    // data-layout="rad": kompakt, alla fält på en rad (panelen under "Välj din bil"-knappen).
    if (this.rot.getAttribute('data-layout') === 'rad') this.rot.classList.add('dg-bilval--rad');
    // data-stegvis (Tim 2026-10-11): bara "Bilmärke *" tills märket är valt, sedan resten av fälten.
    this.stegvis = this.rot.hasAttribute('data-stegvis');
    if (this.stegvis) this.rot.classList.add('dg-bilval--stegvis');
    var rubrik = this.rot.getAttribute('data-rubrik');
    var pil = '<svg width="11" height="18" viewBox="0 0 11 18" fill="none" aria-hidden="true"><path d="M1.5 1.5 9 9l-7.5 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    this.rot.innerHTML =
      (rubrik ? '<h2 class="dg-bilval__rubrik">' + escHtml(rubrik) + '</h2>' : '') +
      '<div class="dg-bilval__falt" data-falt></div>' +
      '<div class="dg-bilval__knappar">' +
      '<button type="button" class="dg-bilval__visa" data-visa disabled><span>' + escHtml(this.rot.getAttribute('data-knapp') || 'Visa delar') + '</span>' + pil + '</button>' +
      '<button type="button" class="dg-bilval__rensa" data-rensa hidden>Rensa</button>' +
      '</div>';
    this.faltEl = this.rot.querySelector('[data-falt]');
    this.visaEl = this.rot.querySelector('[data-visa]');
    this.rensaEl = this.rot.querySelector('[data-rensa]');
    var self = this;
    this.visaEl.addEventListener('click', function () { self.visa(); });
    this.rensaEl.addEventListener('click', function () { self.steg = []; self.ankare = null; self.val = {}; self.rita(); });
  };

  // Tomt fält visar bara fältnamnet (grått om låst); ifyllt fält visar namnet litet överst och värdet under.
  function skapaSelect(id, namn, alternativ, valt, las, valfritt) {
    var w = document.createElement('div');
    var ifylld = !!valt && alternativ.indexOf(valt) > -1;
    w.className = 'dg-bilval__faltgrupp' + (las ? ' is-last' : '') + (valfritt ? ' is-valfritt' : '') + (ifylld ? '' : ' is-tom');
    var lbl = document.createElement('label');
    lbl.setAttribute('for', id);
    lbl.textContent = namn;
    var s = document.createElement('select');
    s.id = id;
    // select-init/semantic-select-initialized: temats plugin-selects.js ska lämna väljaren native.
    s.className = 'dg-bilval__select select-init semantic-select-initialized';
    s.disabled = !!las;
    var ph = document.createElement('option');
    ph.value = '';
    ph.textContent = namn;
    s.appendChild(ph);
    alternativ.forEach(function (a, i) {
      var o = document.createElement('option');
      o.value = String(i);
      o.textContent = a;
      if (a === valt) { o.selected = true; s.title = a; } // hela namnet vid hovring om det kapas
      s.appendChild(o);
    });
    w.appendChild(lbl);
    w.appendChild(s);
    return { w: w, s: s };
  }

  Valjare.prototype.rita = function () {
    var self = this, id = this.rot.id || (this.rot.id = 'dg-bilval-' + Math.random().toString(36).slice(2, 7));
    this.faltEl.innerHTML = '';
    this.poster = [];
    var niva = synliga(this.reg.trad);

    // Tims beslut 2026-09-30: alla fält syns hela tiden – Bilmärke, Modell, Generation, Utrustning,
    // Variant. De som inte kan väljas än, eller inte finns för bilen, är gråa med bara fältnamnet.
    var visade = {};

    // 1. Fasta steg (i ordning).
    var i = 0;
    for (;;) {
      var valdNod = this.steg[i];
      var typ = i >= 2 ? typAvGrupp(niva) : null;
      if (typ) visade[typ] = true;
      var namn = i === 0 ? 'Bilmärke' : i === 1 ? 'Modell' : TYPNAMN[typ];
      var f = skapaSelect(id + '-' + i, namn, niva.map(function (n) { return n.l; }), valdNod && valdNod.l, false, false);
      if (i === 0 && this.stegvis) { // stjärnan: bara bilmärket är obligatoriskt
        f.s.options[0].textContent = namn + ' *';
        f.s.setAttribute('aria-required', 'true');
      }
      (function (nivaNoder, index) {
        f.s.addEventListener('change', function () {
          // Tomt val (fältnamnet) = avmarkera. Number('') är 0, så det måste fångas före uppslaget.
          var nod = this.value === '' ? null : nivaNoder[Number(this.value)];
          self.steg = self.steg.slice(0, index);
          self.val = {};
          self.ankare = null;
          if (nod) { self.steg.push(nod); if (arAnkare(nod, index)) self.ankare = nod; }
          self.rita();
          self.fokusera(index + 1);
        });
      })(niva, i);
      this.faltEl.appendChild(f.w);
      if (!valdNod || arAnkare(valdNod, i)) break;
      niva = synliga(valdNod.b);
      i++;
    }

    function last(nyckel, namn, valfritt) {
      self.faltEl.appendChild(skapaSelect(id + '-l-' + nyckel, namn, [], null, true, valfritt).w);
    }

    if (!this.ankare) {
      // 2a. Innan generationen är vald: resten låst.
      if (!this.steg.length) last('O', 'Modell');
      if (!visade.G) last('G', 'Generation');
      ['U', 'V'].forEach(function (t) { if (!visade[t]) last(t, TYPNAMN[t], true); });
    } else {
      // 2b. Generationen (ankaret) är vald: valfria fält under ankaret, i ordningen Utrustning, Variant.
      if (!visade.G) last('G', 'Generation');
      this.poster = this.ankare.b ? poster(this.ankare) : [];
      var harFalt = {};
      falt(this.poster)
        .sort(function (a, b) { return 'UV'.indexOf(a.k[0]) - 'UV'.indexOf(b.k[0]) || a.k.localeCompare(b.k); })
        .forEach(function (fa) {
          var ovriga = self.poster.filter(function (p) {
            return Object.keys(self.val).every(function (k) { return k === fa.k || p.varden[k] === self.val[k]; });
          });
          var alt = unika(ovriga.map(function (p) { return p.varden[fa.k]; }).filter(Boolean));
          if (!alt.length) { delete self.val[fa.k]; return; }
          harFalt[fa.k[0]] = true;
          var g = skapaSelect(id + '-' + fa.k.replace('#', '-'), fa.namn, alt, self.val[fa.k], false, true);
          g.s.addEventListener('change', function () {
            if (this.value === '') delete self.val[fa.k];
            else self.val[fa.k] = alt[Number(this.value)];
            self.rita();
          });
          self.faltEl.appendChild(g.w);
        });
      ['U', 'V'].forEach(function (t) { if (!visade[t] && !harFalt[t]) last(t, TYPNAMN[t], true); });
    }

    // Stegvis: övriga fält döljs tills bilmärket är valt (assets/dg-bilval.css, .is-bara-marke).
    this.faltEl.classList.toggle('is-bara-marke', this.stegvis && !this.steg.length);
    // Tims beslut 2026-09-30: "Visa delar" går att trycka redan efter bilmärket.
    this.visaEl.disabled = !this.steg.length;
    this.rensaEl.hidden = !this.steg.length;
  };

  Valjare.prototype.fokusera = function (index) {
    var s = this.faltEl.querySelectorAll('select:not(:disabled)')[index];
    if (s && window.matchMedia('(min-width: 750px)').matches) s.focus();
  };

  Valjare.prototype.traff = function () {
    var self = this;
    if (!this.ankare) {
      // Innan generationen: allt under senast valda nod (bilmärke, modell …).
      var sista = this.steg[this.steg.length - 1];
      if (!sista) return [];
      var alla = [];
      (function ga(n) { if (n._n <= 0) return; if (n.b) n.b.forEach(ga); else alla = alla.concat(n.s); })(sista);
      return unika(alla);
    }
    if (!this.ankare.b) return this.ankare.s.slice();
    var sel = [];
    this.poster.forEach(function (p) {
      var ok = Object.keys(self.val).every(function (k) { return p.varden[k] === self.val[k]; });
      if (ok) sel = sel.concat(p.sel);
    });
    return unika(sel);
  };

  Valjare.prototype.etiketter = function () {
    var self = this, ut = this.steg.map(function (n) { return n.l; });
    if (this.ankare && this.ankare.b) {
      falt(this.poster).forEach(function (fa) { if (self.val[fa.k]) ut.push(self.val[fa.k]); });
    }
    return ut;
  };

  Valjare.prototype.visa = function () {
    var sel = this.traff();
    if (!sel.length) return;
    var marke = this.steg[0];
    var bil = {
      v: 1, steg: this.steg.map(function (n) { return n.l; }), val: Object.assign({}, this.val),
      etiketter: this.etiketter(), sel: sel, samling: marke.h || slugga(marke.l)
    };
    sparaBil(bil);
    var fortsatt = this.rot.dispatchEvent(new CustomEvent('dg-bilval:visa', { bubbles: true, cancelable: true, detail: { sel: sel, etiketter: bil.etiketter, bil: bil } }));
    if (fortsatt) gaTillDelar(bil, this.reg);
  };

  // Förifyller väljaren med kundens sparade bil (om den finns kvar i registret).
  Valjare.prototype.aterstall = function (bil) {
    var niva = this.reg.trad, steg = [];
    for (var i = 0; i < bil.steg.length; i++) {
      var nod = synliga(niva).filter(function (n) { return n.l === bil.steg[i]; })[0];
      if (!nod) return;
      steg.push(nod);
      if (arAnkare(nod, i)) { this.ankare = nod; break; }
      niva = nod.b;
    }
    this.steg = steg;
    if (this.ankare) this.val = Object.assign({}, bil.val || {});
  };


  // ---------- Raden under sidhuvudet ----------
  // <div data-dg-bilbar data-register="…" [data-hem]></div>
  //   Utan bil: knappen "Välj din bil" som fäller ut väljaren (radläge). På startsidan (data-hem) döljs
  //   knappen eftersom det stora kortet finns där.
  //   Med bil:  fliken "Vald bil: <bil> ✕". Klick på bilen fäller ut väljaren för att byta; ✕ tar bort bilen.
  var BIL_IKON = '<svg class="dg-bilbar__ikon" width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 16.5h14M4.5 12.5 6.2 8a2 2 0 0 1 1.9-1.3h7.8A2 2 0 0 1 17.8 8l1.7 4.5M4 12.5h16a1 1 0 0 1 1 1v3.5h-2.2M4 12.5a1 1 0 0 0-1 1v3.5h2.2" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/><circle cx="7.5" cy="17.2" r="1.7" stroke="currentColor" stroke-width="1.7"/><circle cx="16.5" cy="17.2" r="1.7" stroke="currentColor" stroke-width="1.7"/></svg>';
  var LANK_IKON = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M10 14a3.5 3.5 0 0 0 5 0l4-4a3.5 3.5 0 0 0-5-5l-.5.5M14 10a3.5 3.5 0 0 0-5 0l-4 4a3.5 3.5 0 0 0 5 5l.5-.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHEV = '<svg class="dg-bilbar__chev" width="12" height="8" viewBox="0 0 12 8" fill="none" aria-hidden="true"><path d="M1 1.5 6 6.5l5-5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function startaBar(rot) {
    if (rot.__dgBilbar) return;
    rot.__dgBilbar = true;
    var hem = rot.hasAttribute('data-hem');
    // Utfälld (Tim 2026-10-11): på kategorisidor och sökresultat utan vald bil ligger väljaren öppen överst
    // ("Välj din bil för att se delar") i stället för knappen. Fäst rad och vald bil som vanligt.
    var utfalld = rot.hasAttribute('data-utfalld');
    var utfText = rot.getAttribute('data-utfalld-text');
    rot.classList.add('dg-bilbar');
    rot.innerHTML =
      (utfalld ?
        '<div class="dg-bilbar__utfalld" hidden><div class="dg-bilbar__utfalld-inre">' +
          '<div class="dg-bilbar__utfalld-huvud">' +
            '<span class="dg-bilbar__utfalld-ikon">' + BIL_IKON + '</span>' +
            '<div><p class="dg-bilbar__utfalld-rubrik">' + escHtml(rot.getAttribute('data-utfalld-rubrik') || 'Välj din bil för att se delar') + '</p>' +
            (utfText ? '<p class="dg-bilbar__utfalld-text">' + escHtml(utfText) + '</p>' : '') + '</div>' +
          '</div>' +
          '<div data-dg-bilval data-layout="rad" data-stegvis data-register="' + escHtml(rot.getAttribute('data-register')) + '" data-knapp="Visa delar"' + (rot.hasAttribute('data-testlage') ? ' data-testlage' : '') + '></div>' +
        '</div></div>'
      : '') +
      '<div class="dg-bilbar__rad">' +
        '<button type="button" class="dg-bilbar__knapp" data-bb-oppna aria-expanded="false">' + BIL_IKON + '<span>' + escHtml(rot.getAttribute('data-knapp') || 'Välj din bil') + '</span>' + CHEV + '</button>' +
        '<div class="dg-bilbar__vald" hidden>' +
          BIL_IKON + '<span class="dg-bilbar__etikett">Vald bil:</span>' +
          '<button type="button" class="dg-bilbar__bil" data-bb-oppna aria-expanded="false"></button>' +
          '<button type="button" class="dg-bilbar__kryss" data-bb-rensa aria-label="Ta bort vald bil">' +
            '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="m2 2 10 10M12 2 2 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
          '</button>' +
        '</div>' +
      '</div>' +
      '<div class="dg-bilbar__panel" hidden>' +
        '<div class="dg-bilbar__panel-inre">' +
          '<div data-dg-bilval data-layout="rad" data-stegvis data-register="' + escHtml(rot.getAttribute('data-register')) + '" data-knapp="Visa delar"' + (rot.hasAttribute('data-testlage') ? ' data-testlage' : '') + '></div>' +
          '<button type="button" class="dg-bilbar__dela" data-bb-dela hidden>' + LANK_IKON + '<span>Kopiera länk till bilen</span></button>' +
          '<button type="button" class="dg-bilbar__stang" data-bb-stang aria-label="Stäng">' +
            '<svg width="16" height="16" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="m2 2 10 10M12 2 2 12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>' +
          '</button>' +
        '</div>' +
      '</div>';
    var knapp = rot.querySelector('.dg-bilbar__knapp');
    var vald = rot.querySelector('.dg-bilbar__vald');
    var bilEl = rot.querySelector('.dg-bilbar__bil');
    var panel = rot.querySelector('.dg-bilbar__panel');
    var dela = rot.querySelector('[data-bb-dela]');
    var rad = rot.querySelector('.dg-bilbar__rad');
    var utf = rot.querySelector('.dg-bilbar__utfalld');
    starta(panel.querySelector('[data-dg-bilval]'));
    if (utf) starta(utf.querySelector('[data-dg-bilval]'));

    function oppen(ja) {
      panel.hidden = !ja;
      rot.classList.toggle('is-oppen', ja);
      Array.prototype.forEach.call(rot.querySelectorAll('[data-bb-oppna]'), function (b) { b.setAttribute('aria-expanded', ja ? 'true' : 'false'); });
    }
    function visaLage() {
      var bil = lasBil();
      var harBil = !!(bil && bil.etiketter && bil.etiketter.length);
      vald.hidden = !harBil;
      var fast = rot.classList.contains('is-fast');
      knapp.hidden = harBil || (hem && !fast);
      if (harBil) bilEl.textContent = bil.etiketter.join(' ');
      if (dela) dela.hidden = !harBil;
      rot.hidden = !harBil && hem && panel.hidden && !fast;
      if (utf) {
        var visaUtf = !harBil && !fast;
        if (visaUtf && !panel.hidden) oppen(false);
        utf.hidden = !visaUtf;
        rad.hidden = visaUtf;
        rot.classList.toggle('is-utfalld', visaUtf);
      }
    }
    rot.addEventListener('click', function (e) {
      if (e.target.closest('[data-bb-oppna]')) { oppen(panel.hidden); return; }
      if (e.target.closest('[data-bb-stang]')) { oppen(false); return; }
      if (e.target.closest('[data-bb-rensa]')) { oppen(false); sparaBil(null); }
    });
    document.addEventListener('click', function (e) { if (!panel.hidden && !rot.contains(e.target)) oppen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') oppen(false); });
    rot.addEventListener('dg-bilval:visa', function () { oppen(false); });
    document.addEventListener('dg-bilval:bil', visaLage);
    rot.addEventListener('dg-bilbar:fast', visaLage);
    visaLage();
    fastRad(rot);
  }

  // Fast rad (Tims önskan 2026-10-07): när raden skrollas ur bild fästs den överst, med eller utan vald bil.
  // Temats #root har overflow: hidden, så CSS position: sticky fungerar inte. En markör före raden visar när den
  // har passerat, och sektionen behåller radens höjd så att sidan inte hoppar. På startsidan utan bil syns raden
  // först i fast läge (det stora kortet finns överst).
  function fastRad(rot) {
    var sektion = rot.parentNode;
    if (!sektion || rot.__dgFast) return;
    rot.__dgFast = true;
    var markor = document.createElement('div');
    markor.setAttribute('aria-hidden', 'true');
    markor.style.cssText = 'height:0;margin:0;padding:0;';
    sektion.insertBefore(markor, rot);
    var fast = false;
    function satt(ja) {
      if (ja === fast) return;
      fast = ja;
      sektion.style.minHeight = ja ? rot.offsetHeight + 'px' : '';
      rot.classList.toggle('is-fast', ja);
      rot.dispatchEvent(new CustomEvent('dg-bilbar:fast', { detail: ja }));
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (poster) {
        var r = poster[poster.length - 1];
        satt(!r.isIntersecting && r.boundingClientRect.top < 0);
      }).observe(markor);
    } else {
      window.addEventListener('scroll', function () { satt(markor.getBoundingClientRect().top < 0); }, { passive: true });
    }
  }

  // ---------- Plan A: skicka kunden till delarna och filtrera listsidor ----------
  var SEL_P = 'filter.p.m.custom.sel_ids';
  var MARKE_P = 'filter.p.m.custom.bilmarke';
  var FILTERGRANS = 5000; // Shopify filtrerar inte kollektioner med fler produkter

  function slugga(s) {
    return String(s).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function harBil(bil) { return !!(bil && bil.steg && bil.steg.length && bil.sel && bil.sel.length); }
  function bilSamling(bil) { return bil.samling || slugga(bil.steg[0]); }
  function baraMarke(bil) { return bil.steg.length === 1 && !Object.keys(bil.val || {}).length; }

  // Bilens filter som [namn, värde]-par. Bara märke valt: märkesfiltret, även på märkessidan, så att
  // bara produkter med passform visas (Tims beslut 2026-10-04: produkter utan SEL-ID räknas inte).
  function bilFilter(bil) {
    if (!harBil(bil)) return [];
    if (baraMarke(bil)) return [[MARKE_P, bil.steg[0]]];
    return bil.sel.map(function (s) { return [SEL_P, s]; });
  }

  // Sidans läge sätts av sektionen "Bilväljare – rad" (data-sida, data-samling, data-antal).
  function sidInfo() {
    var el = document.querySelector('[data-dg-bilbar][data-sida]');
    if (!el) return null;
    var sida = el.getAttribute('data-sida');
    if (sida === 'search') return { sok: true, register: el.getAttribute('data-register') };
    if (sida !== 'collection') return null;
    var omfang = [];
    try { omfang = JSON.parse(el.getAttribute('data-omfang') || '[]'); } catch (e) { /* utan avgränsning */ }
    return { samling: el.getAttribute('data-samling'), antal: parseInt(el.getAttribute('data-antal'), 10) || 0, register: el.getAttribute('data-register'), omfang: omfang };
  }
  function markesHandles(reg) { return reg.trad.map(function (m) { return m.h || slugga(m.l); }); }

  // Adressen med bilens filter. Tidigare bilfilter och sidnummer tas bort, övriga parametrar behålls.
  function medFilter(href, par) {
    var u = new URL(href, location.href);
    u.searchParams.delete(SEL_P); u.searchParams.delete(MARKE_P); u.searchParams.delete('page');
    par.forEach(function (p) { u.searchParams.delete(p[0]); });
    par.forEach(function (p) { u.searchParams.append(p[0], p[1]); });
    return u.pathname + u.search + u.hash;
  }
  function filterNyckel(par) { return par.map(function (p) { return p.join('='); }).sort().join('&'); }
  // Bilfiltret som redan står i en adress, som [namn, värde]-par.
  function filterIAdress(u) {
    return u.searchParams.getAll(SEL_P).map(function (v) { return [SEL_P, v]; })
      .concat(u.searchParams.getAll(MARKE_P).map(function (v) { return [MARKE_P, v]; }));
  }

  // Skydd mot omladdningsslinga om Shopify skulle skriva om adressen.
  // Slinga = samma mål igen från en annan adress än förra gången (Shopify skrev om adressen). Samma sida
  // igen (kunden klickar på samma länk) är ingen slinga. Samma regel i sections/dg-bilval-bar.liquid.
  // Sidans innehåll döljs tills den nya sidan laddats (klassen dg-bilval-byter, CSS i raden under sidhuvudet).
  function omdirigera(mal) {
    var rot = document.documentElement;
    if (rot.classList.contains('dg-bilval-byter')) return; // den tidiga omdirigeringen är redan på väg
    var fran = location.pathname + location.search;
    try {
      var forra = JSON.parse(sessionStorage.getItem('dg_bilval_omdir') || 'null');
      if (forra && forra.mal === mal && forra.fran !== fran && Date.now() - forra.tid < 10000) { visaSidan(); return; }
      sessionStorage.setItem('dg_bilval_omdir', JSON.stringify({ mal: mal, fran: fran, tid: Date.now() }));
    } catch (e) { /* utan sessionStorage: omdirigera ändå */ }
    rot.classList.add('dg-bilval-byter');
    laddband();
    location.replace(mal);
  }
  // Visar innehållet om den tidiga omdirigeringen dolde det i väntan på beslut (klassen dg-bilval-vantar).
  function visaSidan() { document.documentElement.classList.remove('dg-bilval-vantar'); }

  // "Visa delar": på sökresultatet eller en kategorisida (högst 5 000 produkter) filtreras samma sida,
  // annars märkessidan (från en stor sida med dess avgränsning, från produktsidan med alla delar till bilen).
  // Tim 2026-10-29: produktsidan stannade förut (rutan "Passar din bil" uppdaterades), men då hände inget synligt.
  function gaTillDelar(bil, reg) {
    var info = sidInfo(), marken = markesHandles(reg);
    var stanna = info && (info.sok || (info.antal <= FILTERGRANS && marken.indexOf(info.samling) === -1));
    var stor = info && !info.sok && info.antal > FILTERGRANS && marken.indexOf(info.samling) === -1;
    laddband();
    location.href = stanna
      ? medFilter(location.href, bilFilter(bil))
      : medFilter('/collections/' + bilSamling(bil), bilFilter(bil).concat(stor ? info.omfang : []));
  }

  // Vid sidladdning: listsidan ska visa kundens bil, och utan bil inget bilfilter. Den tidiga omdirigeringen i
  // sections/dg-bilval-bar.liquid gör samma sak innan produkterna ritas; det här är reserven och skriver om länkarna.
  function filtreraSidan() {
    if (window.Shopify && window.Shopify.designMode) return;
    var info = sidInfo(), bil = lasBil();
    if (!info) { lankarMedBil(bil); return; } // startsidan, produktsidor m.m.
    var nuvarande = filterIAdress(new URL(location.href));
    if (!harBil(bil)) {
      if (nuvarande.length) omdirigera(medFilter(location.href, []));
      visaSidan();
      return;
    }
    if (info.sok) { // sökresultatet: bara produkter som passar bilen
      if (filterNyckel(bilFilter(bil)) !== filterNyckel(nuvarande)) omdirigera(medFilter(location.href, bilFilter(bil)));
      else lankarMedBil(bil);
      return;
    }
    hamtaRegister(info.register).then(function (reg) {
      var marken = markesHandles(reg);
      var arMarkessida = marken.indexOf(info.samling) > -1;
      if (arMarkessida && info.samling !== bilSamling(bil)) skrivOmLankar(bil, marken); // ett annat märke som kunden själv valt
      // Paraplysida → märkessidan, med adressens övriga parametrar kvar (utm, gclid m.m.).
      else if (!arMarkessida && info.antal > FILTERGRANS) omdirigera(medFilter('/collections/' + bilSamling(bil) + location.search, bilFilter(bil).concat(info.omfang)));
      else if (filterNyckel(bilFilter(bil)) !== filterNyckel(nuvarande)) omdirigera(medFilter(location.href, bilFilter(bil)));
      else skrivOmLankar(bil, marken);
      visaSidan();
    }).catch(visaSidan);
  }

  // Länkar till kategorisidor får bilens filter direkt (på alla sidor), så att kunden slipper en omladdning.
  // Utan bil tas ett gammalt bilfilter bort ur länkarna.
  function lankarMedBil(bil) {
    var el = document.querySelector('[data-dg-bilbar][data-register]');
    if (!el) return;
    hamtaRegister(el.getAttribute('data-register')).then(function (reg) { skrivOmLankar(bil, markesHandles(reg)); }).catch(function () {});
  }
  function skrivOmLankar(bil, marken) {
    var par = bilFilter(bil); // [] utan bil
    Array.prototype.forEach.call(document.querySelectorAll('a[href*="/collections/"]'), function (a) {
      var u;
      try { u = new URL(a.getAttribute('href'), location.href); } catch (e) { return; }
      if (u.host !== location.host) return;
      var m = u.pathname.match(/\/collections\/([^\/]+)\/?$/);
      if (!m) return; // produktlänkar o.d.
      if (par.length && marken.indexOf(m[1]) > -1 && m[1] !== bilSamling(bil)) return; // andra märkens sidor
      // Har länken redan bilens filter (sidnumreringen, sortering) ska den lämnas, annars försvinner page=.
      if (filterNyckel(filterIAdress(u)) === filterNyckel(par)) return;
      a.setAttribute('href', medFilter(u.href, par));
    });
  }

  // Sökrutan: skickar bilens filter med sökningen, så att resultatet direkt visar delar för bilen.
  // (Sökförslagen i rutan medan man skriver kan Shopify inte filtrera på metafält.)
  document.addEventListener('submit', function (e) {
    var f = e.target, bil = lasBil();
    if (!f || f.tagName !== 'FORM' || !harBil(bil)) return;
    var vag;
    try { vag = new URL(f.getAttribute('action') || '', location.href).pathname; } catch (err) { return; }
    if (!/\/search\/?$/.test(vag)) return;
    Array.prototype.forEach.call(f.querySelectorAll('input[data-dg-bilfilter]'), function (i) { i.remove(); });
    bilFilter(bil).forEach(function (p) {
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = p[0]; i.value = p[1]; i.setAttribute('data-dg-bilfilter', '');
      f.appendChild(i);
    });
  }, true);

  // ✕ (ingen bil längre): ta bort bilfiltret från sidan man står på.
  // Ny bil på en sida som inte är en listsida (t.ex. produktsidan): länkarna får den nya bilens filter.
  document.addEventListener('dg-bilval:bil', function (e) { if (!e.detail || !sidInfo()) filtreraSidan(); });

  // ---------- "Passar din bil" på produktsidan (snippets/dg-bilval-passar.liquid) ----------
  var IKON_BOCK = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="m5 12.5 4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var IKON_KRYSS = '<svg width="16" height="16" viewBox="0 0 14 14" fill="none"><path d="m2.5 2.5 9 9m0-9-9 9" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';

  // Bilen utan märket: "C-Klass 2021- (W206) · Standardutrustning".
  function bilKort(bil) {
    var e = bil.etiketter.slice(1);
    return e.slice(0, 2).join(' ') + (e.length > 2 ? ' · ' + e.slice(2).join(' · ') : '');
  }
  // passar: alla bilens SEL-ID finns på produkten (eller universaldel) · delvis: några · passar-inte: inga.
  function passarLage(bil, produktSel) {
    if (!harBil(bil) || baraMarke(bil)) return null;
    if (produktSel.indexOf('SEL-000000') > -1) return 'passar';
    var traff = bil.sel.filter(function (s) { return produktSel.indexOf(s) > -1; }).length;
    if (!traff) return 'passar-inte';
    return traff === bil.sel.length ? 'passar' : 'delvis';
  }
  function ritaPassar(el) {
    var bil = lasBil();
    var lage = passarLage(bil, (el.getAttribute('data-sel') || '').split(',').filter(Boolean));
    el.hidden = !lage;
    if (!lage) { el.innerHTML = ''; return; }
    var rubrik = { 'passar': 'Passar din bil', 'delvis': 'Passar vissa utföranden', 'passar-inte': 'Passar inte din bil' }[lage];
    var under = bilKort(bil) + (lage === 'delvis' ? ' · välj utrustning och variant' : '');
    el.className = 'dg-passar is-' + lage;
    el.innerHTML =
      '<span class="dg-passar__ikon" aria-hidden="true">' + (lage === 'passar-inte' ? IKON_KRYSS : IKON_BOCK) + '</span>' +
      '<span class="dg-passar__text"><strong class="dg-passar__rubrik">' + rubrik + '</strong>' +
      '<span class="dg-passar__bil">' + escHtml(under) + '</span></span>' +
      (lage === 'passar-inte'
        ? '<a class="dg-passar__knapp" href="' + escHtml(medFilter('/collections/' + bilSamling(bil), bilFilter(bil))) + '">Delar till din bil</a>'
        : '<button type="button" class="dg-passar__knapp" data-dg-byt-bil>Byt bil</button>');
  }
  function startaPassar() { Array.prototype.forEach.call(document.querySelectorAll('[data-dg-passar]'), ritaPassar); }
  document.addEventListener('dg-bilval:bil', startaPassar);
  // "Byt bil": öppna raden under sidhuvudet.
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-dg-byt-bil]')) return;
    var oppna = document.querySelector('[data-dg-bilbar] .dg-bilbar__vald:not([hidden]) .dg-bilbar__bil') ||
      document.querySelector('[data-dg-bilbar] .dg-bilbar__knapp');
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // Utfälld väljare överst (ingen bil): den är redan öppen, fokusera bilmärket i stället.
    var utfFalt = document.querySelector('[data-dg-bilbar] .dg-bilbar__utfalld:not([hidden]) select');
    if (utfFalt) { setTimeout(function () { utfFalt.focus(); }, 300); return; }
    if (oppna) setTimeout(function () { oppna.click(); }, 60);
  });

  // ---------- Tom kategori med bilfilter (snippets/dg-bilval-tom.liquid) ----------
  function startaTom() {
    var bil = lasBil();
    if (!harBil(bil)) return; // utan bil tar filtreraSidan bort filtret
    Array.prototype.forEach.call(document.querySelectorAll('[data-dg-tom]'), function (el) {
      var namn = el.querySelector('[data-dg-tom-bil]');
      if (namn) namn.textContent = (bil.etiketter || bil.steg).join(' ');
      var delar = el.querySelector('[data-dg-tom-delar]');
      if (delar) {
        delar.setAttribute('href', medFilter('/collections/' + bilSamling(bil), bilFilter(bil)));
        delar.hidden = false;
      }
    });
  }
  // "Ta bort bilfiltret": samma som ✕ – bilen tas bort och filtreraSidan visar kategorin utan filter.
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-dg-ta-bort-bil]')) return;
    sparaBil(null);
  });

  // ---------- Länk till en bil (sms, mejl, Google, "Kopiera länk till bilen") ----------
  // Kommer kunden utifrån till en adress med bilfilter gäller bilen i adressen: den slås upp i registret och
  // sparas som kundens bil. Inne på sajten gäller den sparade bilen som förut (byt bil, ✕, bakåt).
  // Samma regel i det tidiga skriptet i sections/dg-bilval-bar.liquid.
  var DELA_P = 'dg_bil';
  function lankNyckel(u) { return u.pathname + '|' + filterNyckel(filterIAdress(u)); }
  function franLank() {
    var u = new URL(location.href);
    if (!filterIAdress(u).length) return false;
    var ref = '';
    try { ref = document.referrer ? new URL(document.referrer).host : ''; } catch (e) {}
    if (!u.searchParams.has(DELA_P) && ref === location.host) return false;
    try { if (sessionStorage.getItem('dg_bilval_lank') === lankNyckel(u)) return false; } catch (e) {}
    return true;
  }

  // Bygger kundens bil ur adressens filter, på samma sätt som väljaren gör vid "Visa delar".
  function bilFranAdress(reg, u) {
    var sel = unika(u.searchParams.getAll(SEL_P)), marke = u.searchParams.getAll(MARKE_P);
    var v = Object.create(Valjare.prototype);
    v.reg = reg; v.steg = []; v.ankare = null; v.val = {}; v.poster = [];
    if (sel.length) {
      var vagar = [];
      (function ga(noder, vag) {
        noder.forEach(function (n) {
          var v2 = vag.concat([n]);
          if (n.b) ga(n.b, v2);
          else if ((n.s || []).some(function (s) { return sel.indexOf(s) > -1; })) vagar.push(v2);
        });
      })(reg.trad, []);
      if (!vagar.length) return null;
      var gem = [];
      for (var i = 0; ; i++) {
        var n = vagar[0][i];
        if (!n || !vagar.every(function (p) { return p[i] === n; })) break;
        gem.push(n);
      }
      if (!gem.length) return null; // olika bilmärken
      for (var j = 0; j < gem.length; j++) {
        v.steg.push(gem[j]);
        if (arAnkare(gem[j], j)) { v.ankare = gem[j]; break; }
      }
      if (v.ankare && v.ankare.b) {
        v.poster = poster(v.ankare);
        var traffar = v.poster.filter(function (p) { return p.sel.some(function (s) { return sel.indexOf(s) > -1; }); });
        falt(v.poster).forEach(function (fa) {
          var varden = unika(traffar.map(function (p) { return p.varden[fa.k]; }));
          if (varden.length === 1 && varden[0]) v.val[fa.k] = varden[0];
        });
      }
    } else if (marke.length === 1) {
      var m = synliga(reg.trad).filter(function (x) { return x.l === marke[0]; })[0];
      if (!m) return null;
      v.steg = [m];
    } else return null;
    var traff = v.traff();
    if (!traff.length) return null;
    var forsta = v.steg[0];
    return {
      v: 1, steg: v.steg.map(function (x) { return x.l; }), val: Object.assign({}, v.val),
      etiketter: v.etiketter(), sel: sel.length ? sel : traff, samling: forsta.h || slugga(forsta.l)
    };
  }

  // Sparar bilen ur adressen (om den finns i registret) och tar bort delningsmärket ur adressen.
  function sparaBilFranLank() {
    var el = document.querySelector('[data-dg-bilbar][data-register]') || document.querySelector('[data-dg-bilval][data-register]');
    var u = new URL(location.href);
    try { sessionStorage.setItem('dg_bilval_lank', lankNyckel(u)); } catch (e) {}
    if (u.searchParams.has(DELA_P)) {
      u.searchParams.delete(DELA_P);
      try { history.replaceState(history.state, '', u.pathname + u.search + u.hash); } catch (e) {}
    }
    if (!el) return Promise.resolve();
    return hamtaRegister(el.getAttribute('data-register')).then(function (reg) {
      var bil = bilFranAdress(reg, u);
      if (bil) sparaBil(bil);
    }).catch(function () {});
  }

  // "Kopiera länk till bilen" i panelen under "Vald bil".
  function delningsLank(bil) {
    var u = new URL(medFilter('/collections/' + bilSamling(bil), bilFilter(bil)), location.origin);
    u.searchParams.set(DELA_P, '1');
    return u.href;
  }
  document.addEventListener('click', function (e) {
    var knapp = e.target.closest && e.target.closest('[data-bb-dela]');
    if (!knapp) return;
    var bil = lasBil();
    if (!harBil(bil)) return;
    var lank = delningsLank(bil), text = knapp.querySelector('span');
    function klart(ok) {
      if (!text) return;
      var forut = text.getAttribute('data-text') || text.textContent;
      text.setAttribute('data-text', forut);
      text.textContent = ok ? 'Länken är kopierad' : 'Kunde inte kopiera';
      setTimeout(function () { text.textContent = forut; }, 2500);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(lank).then(function () { klart(true); }, function () { window.prompt('Kopiera länken:', lank); });
    } else window.prompt('Kopiera länken:', lank);
  });

  // ---------- Start ----------
  function starta(rot) {
    if (rot.__dgBilval) return;
    rot.__dgBilval = true;
    var url = rot.getAttribute('data-register');
    rot.classList.add('is-laddar');
    hamtaRegister(url).then(function (reg) {
      rot.classList.remove('is-laddar');
      rot.__valjare = new Valjare(rot, reg);
    }).catch(function (e) {
      rot.classList.remove('is-laddar');
      rot.innerHTML = '<p class="dg-bilval__fel">Bilväljaren kunde inte laddas. Ladda om sidan och försök igen.</p>';
      if (window.console) console.error(e);
    });
  }

  function startaAlla() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-dg-bilbar]'), startaBar);
    Array.prototype.forEach.call(document.querySelectorAll('[data-dg-bilval]'), starta);
  }

  // malAdress: märkessidan med bilens filter (för testsidor och felsökning).
  window.DGBilval = {
    starta: starta, startaBar: startaBar, lasBil: lasBil, sparaBil: sparaBil,
    malAdress: function (bil) { return medFilter('/collections/' + bilSamling(bil), bilFilter(bil)); }
  };
  function startaSidan() {
    startaAlla();
    var klar = franLank() ? sparaBilFranLank() : Promise.resolve();
    klar.then(function () { filtreraSidan(); startaPassar(); startaTom(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startaSidan);
  else startaSidan();
  // Bakåt/framåt kan visa en sparad kopia av sidan (bfcache) utan att skripten körs om. Då kan raden och filtret
  // visa en bil som kunden har bytt eller tagit bort: rita om med den sparade bilen och rätta adressen.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.dispatchEvent(new CustomEvent('dg-bilval:bil', { detail: lasBil() }));
    filtreraSidan();
  });
  document.addEventListener('shopify:section:load', startaAlla);

  // ---------- Laddband vid sidbyte (release 4, Tim 2026-10-11: "animation för varje val … som laddar") ----------
  // Ett tunt grönt band högst upp medan nästa sida laddas: bilväljarens val (Visa delar, ✕, omdirigering) och länkar
  // inom sajten. Försvinner när sidan byts, när man går tillbaka (bfcache) och senast efter 8 s.
  function laddband() {
    var el = document.querySelector('.dg-laddband');
    if (!el && document.body) {
      el = document.createElement('div');
      el.className = 'dg-laddband';
      el.setAttribute('aria-hidden', 'true');
      document.body.appendChild(el);
    }
    if (!el) return;
    el.classList.remove('is-pa');
    void el.offsetWidth; // starta animationen om
    el.classList.add('is-pa');
    clearTimeout(laddband.t);
    laddband.t = setTimeout(function () { el.classList.remove('is-pa'); }, 8000);
  }
  document.addEventListener('click', function (e) {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || (a.target && a.target !== '_self') || a.hasAttribute('download')) return;
    var u;
    try { u = new URL(a.getAttribute('href'), location.href); } catch (x) { return; }
    if (u.origin !== location.origin || (u.pathname === location.pathname && u.search === location.search)) return;
    setTimeout(function () { if (!e.defaultPrevented) laddband(); }, 0); // inte om temat själv tog hand om klicket
  });
  window.addEventListener('pageshow', function (e) {
    var el = document.querySelector('.dg-laddband');
    if (e.persisted && el) el.classList.remove('is-pa');
  });
})();
